import React, { useEffect, useState } from 'react'
import LoaderHelper from '../../../customComponents/Loading/LoaderHelper';
import AuthService from '../../../api/services/AuthService';
import { alertErrorMessage, alertSuccessMessage } from '../../../customComponents/CustomAlertMessage';
import moment from 'moment';
import DashboardHeader from '../../../customComponents/DashboardHeader';

const OpenOrders = (props) => {
  const [allOpenOrders, setAllOpenOrders] = useState([]);
  const [totalAllOpen, setTotalAllOpen] = useState([]);
  const [skipAllOrder, setSkipAllOrder] = useState(0);
  const limitAllorder = 10;


  const handleOpenOrders = async (skipAllOrder, limitAllorder) => {
    try {
      LoaderHelper.loaderStatus(true);
      const result = await AuthService.allOpenOrder(skipAllOrder, limitAllorder)
      if (result?.success) {
        setAllOpenOrders(result?.data);
        setTotalAllOpen(result.total_count);
      } else {
        alertErrorMessage(result?.message);
      }
    } catch (error) { }
    finally { LoaderHelper.loaderStatus(false); }
  };

  const cancelOrder = async (orderId) => {
    await AuthService.cancelOrder(orderId).then((result) => {
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        try {
          alertSuccessMessage('Order Cancelled Successfully');
          handleOpenOrders(skipAllOrder, limitAllorder)
        } catch (error) {
          LoaderHelper.loaderStatus(false);
        }
      } else {
        LoaderHelper.loaderStatus(false);
        alertErrorMessage(result?.message)
      }
    })
  };

  const handlePaginationAllOrder = (action) => {
    if (action === 'prev') {
      if (skipAllOrder - limitAllorder >= 0) {
        setSkipAllOrder(skipAllOrder - limitAllorder);
      }
    } else if (action === 'next') {
      if (skipAllOrder + limitAllorder < totalAllOpen) {
        setSkipAllOrder(skipAllOrder + limitAllorder);
      }
    } else if (action === 'first') {
      setSkipAllOrder(0);
    } else if (action === 'last') {
      const lastPageSkip = Math.floor(totalAllOpen);
      if (totalAllOpen > 10) {
        const data = lastPageSkip - 10
        setSkipAllOrder(data);
      }
    }
  };

  const toFixed = (data) => {
    if (typeof (data) === 'number') {
      return parseFloat(data?.toFixed(6));
    } else {
      return 0;
    }
  }


  useEffect(() => {
    handleOpenOrders(skipAllOrder, limitAllorder)

  }, []);

  return (
    <>


      <div className="dashboard_right">
        <DashboardHeader props={props} />

        <div className="dashboard_listing_section Overview_mid">

          <div className="listing_left_outer full_width transaction_history_t">

            <div className="market_section spotorderhist">
              <div className="top_heading">
                <h4>All open orders </h4>
              </div>
              <div className="dashboard_summary">
                <div className='table-responsive'>
                  <table>
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Date/Time</th>
                        <th>Currency Pair</th>
                        <th>Side</th>
                        <th>Price</th>
                        <th>Quantity</th>
                        <th>Filled</th>
                        <th>Total</th>
                        <th>Status</th>
                        <th className="right_td">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allOpenOrders?.length > 0 ? (
                        allOpenOrders?.map((item, index) => (
                          <tr key={index}>
                            <td >{index + 1}</td>
                            <td >
                              <div className=" justify-content-start" >
                                <span>{moment(item.createdAt).format("DD/MM/YYYY  ")}
                                  <small>{moment(item.createdAt).format("hh:mm A")}</small>
                                </span>
                              </div>
                            </td>
                            <td >{item?.base_currency_short_name + "/" + item?.quote_currency_short_name}</td>
                            <td >{item?.side}</td>
                            <td > {toFixed(item?.price)}</td>
                            <td >{toFixed(item?.quantity)}</td>
                            <td >{toFixed(item?.filled)}</td>
                            <td > {toFixed((item?.price * item?.quantity))} </td>
                            <td >{item?.status}</td>
                            <td className="right_td"> <button className="btn text-danger btn-sm btn-icon" type="button" title="Cancel order" onClick={() => { cancelOrder(item?._id) }}><i className="ri-delete-bin-6-line pr-0"></i>
                            </button></td>
                          </tr>
                        ))
                      ) : (
                        <tr rowSpan="5">
                          <td colSpan="12">
                            <div className="no_data_outer">
                              <div className="no_data_vector">
                                <img src="/images/no_data_vector.svg" alt="no-data" />

                              </div>

                              <p>No Data Available</p>

                            </div>

                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {allOpenOrders?.length > 0 ?
                  < div className="hVPalX gap-2" >
                    <span className="" >{skipAllOrder + 1}-{Math.min(skipAllOrder + limitAllorder, totalAllOpen)} of {totalAllOpen}</span>
                    <div className="sc-eAKtBH gVtWSU">
                      <button type="button" aria-label="First Page" className="sc-gjLLEI kuPCgf" onClick={() => handlePaginationAllOrder('first')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                          <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path>
                          <path fill="none" d="M24 24H0V0h24v24z"></path>
                        </svg>
                      </button>
                      <button type="button" aria-label="Next Page" className="sc-gjLLEI kuPCgf" onClick={() => handlePaginationAllOrder('prev')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                          <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                          <path d="M0 0h24v24H0z" fill="none"></path>
                        </svg>
                      </button>

                      <button type="button" aria-label="Next Page" className="sc-gjLLEI kuPCgf" onClick={() => handlePaginationAllOrder('next')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                          <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                          <path d="M0 0h24v24H0z" fill="none"></path>
                        </svg>
                      </button>
                      <button type="button" className="sc-gjLLEI kuPCgf" onClick={() => handlePaginationAllOrder('last')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                          <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path>
                          <path fill="none" d="M0 0h24v24H0V0z"></path>
                        </svg>
                      </button>
                    </div>
                  </div>
                  :
                  ""
                }

              </div>


            </div>



          </div>


        </div>

      </div>
    </>
  )
}

export default OpenOrders
